module.exports = __webpack_public_path__ + "8bcd4ef47651fcf8c53fe7ae5ef0d4f2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/sofas/sofa-chef.png
// module id = 1592
// module chunks = 0